// Solid icons
import {
    faCalendar,
    faCalendarPlus,
    faEnvelope,
    faLocationDot,
    faPhone,
    faRepeat,
    faUser,
    faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import {
    FaFacebook,
    FaInstagram,
    FaTwitter,
    FaLinkedinIn,
} from "react-icons/fa";
import { formatDate, getMobileNumberByType, getValueOrDash } from "../../../Utils/helpers/commonhelper"
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ContactDetails } from "../../detailPage/Contacts/ContactDetails";
import { useState } from "react";

export const PersonalDealDetails = ({ dealData, setContactId, setShowContactDetails, setCompanyId, setShowCompanyDetails }) => {

    const formatAddress = (data) => {
        if (!data) return "-";

        const addressParts = [
            data?.address?.trim(),
            data?.city_name?.trim(),
            data?.state_name?.trim(),
            data?.country_name?.trim()
        ].filter(part => part && part !== "" && part !== "-");

        return addressParts.length > 0 ? addressParts.join(", ") : "-";
    };
    const iconColor = "#2656a8"
    // Social icon helper for a cleaner look
    const renderSocialIcon = (title, icon, link, color) => {
        const hasLink = link && link !== "" && link !== "-";

        return (
            <div
                className="d-flex align-items-center gap-2"
                onClick={() => hasLink && window.open(link, "_blank")}
                style={{
                    cursor: hasLink ? "pointer" : "default",
                    opacity: hasLink ? 1 : 0.6
                }}
            >
                <span
                    style={{
                        color: color,
                        padding: "8px",
                        background: `${color}10`,
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.2s",
                        minWidth: "34px"
                    }}
                    className={hasLink ? "social-link-hover" : ""}
                >
                    {icon}
                </span>
                <div className="overflow-hidden">
                    <p className="mb-0 " style={miniLabelStyle}>{title}</p>
                    <p
                        className="mb-0 fw-medium text-truncate"
                        style={{
                            fontSize: "12px",
                            color: hasLink ? "#1e293b" : "#cbd5e1"
                        }}
                    >
                        {hasLink ? "View Profile" : getValueOrDash(null)}
                    </p>
                </div>
            </div>
        );
    };

    const renderSection = (title, items, handler) => {
        return (
            <div className={`px-4 py-4 ${title?.toLowerCase()?.split(" ")?.join("_") !== "contact_details" && "border-top"} `}>
                {/* Section Label */}
                <p className="mb-0 " style={{ fontSize: "1.2rem", letterSpacing: "0.3px", fontWeight: 300 }}>{title}</p>

                <Row className="g-3 mt-1">
                    {items.map((item, idx) => (
                        <Col
                            key={idx}
                            md={item.fullWidth ? 12 : 6}
                            className="d-flex align-items-start gap-3"
                        >
                            {/* The Icon inside a subtle tinted box */}
                            {item.icon && (
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-2"
                                    style={{
                                        backgroundColor: "#f1f5f9",
                                        minWidth: "32px",
                                        height: "32px",
                                        color: iconColor
                                    }}
                                >
                                    <FontAwesomeIcon icon={item.icon} size="sm" />
                                </div>
                            )}

                            <div className="overflow-hidden">
                                <span className="mb-0" style={{ ...miniLabelStyle }}>{item.label}</span>
                                <p
                                    className="mb-0 text-truncate"
                                    onClick={() => {
                                        if (!item.isLink) return
                                        handler()
                                    }}
                                    style={{
                                        fontSize: "13px",
                                        color: item.isLink ? "#0099ff" : "#1e293b",
                                        cursor: item.isLink ? "pointer" : "default",
                                        fontSize: item.isLink && "1rem",
                                        fontWeight: item.isLink && 500
                                    }}
                                >
                                    {getValueOrDash(item.value)}
                                </p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div >
        );
    };

    const contactLabels = [
        { label: "Contact Name", value: dealData?.contact_name, isLink: true, type: 'name', },
        { label: "Phone", value: `+${getMobileNumberByType(dealData?.user_phone, "Mobile")}`, icon: faPhone },
        { label: "Personal Phone", value: getMobileNumberByType(dealData?.user_phone, "private"), icon: faPhone },
        { label: "Email", value: dealData?.email, icon: faEnvelope, fullWidth: true },
        { label: "Address", value: formatAddress(dealData), icon: faLocationDot },
    ]

    return (
        <>
            <div
                className="info-sidebar"
                style={{
                    width: "50%",
                    background: "#fff",
                    borderRadius: "12px",
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
                    height: "100%",
                    overflow: "hidden"
                }}
            >

                <div className={`px-4 py-4`}>
                    {/* Section Label */}
                    <p className="mb-0 " style={{ fontSize: "1.2rem", letterSpacing: "0.3px", fontWeight: 300 }}>Contact Details</p>

                    <Row className="g-3 mt-1">
                        {contactLabels.map((item, idx) => (
                            <Col
                                key={idx}
                                md={item.fullWidth ? 12 : 6}
                                className="d-flex align-items-start gap-3"
                            >
                                {/* The Icon inside a subtle tinted box */}
                                {item.icon && (
                                    <div
                                        className="d-flex align-items-center justify-content-center rounded-2"
                                        style={{
                                            backgroundColor: "#f1f5f9",
                                            minWidth: "32px",
                                            height: "32px",
                                            color: iconColor
                                        }}
                                    >
                                        <FontAwesomeIcon icon={item.icon} size="sm" />
                                    </div>
                                )}

                                <div className="overflow-hidden">
                                    <span className="mb-0" style={{ ...miniLabelStyle }}>{item.label}</span>
                                    <p
                                        className="mb-0 text-truncate"
                                        onClick={() => {
                                            setContactId(dealData.contact_id)
                                            setShowContactDetails(true)
                                        }}
                                        style={{
                                            fontSize: "13px",
                                            color: "#0099ff",
                                            cursor: "pointer",
                                            fontSize: "1rem",
                                            fontWeight: 500
                                        }}
                                    >
                                        {getValueOrDash(item.value)}
                                    </p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div >

                {/* Company Details */}
                <div className="px-4 py-3 border-top" >
                    <p className="mb-0 " style={{ fontSize: "1.2rem", letterSpacing: "0.3px", fontWeight: 300 }}>Company Details</p>
                    <div className="mt-2 mb-3">
                        <p
                            onClick={() => {
                                setCompanyId(dealData?.company_id)
                                setShowCompanyDetails(true)
                            }}
                            className="mb-0 " style={{ color: "#0099ff", fontSize: "1.1rem", textTransform: "capitalize", fontWeight: 500, cursor: "pointer" }}>
                            {getValueOrDash(dealData?.company_name)}
                        </p>
                        <div className="d-flex align-items-center gap-1 text-muted" style={{ fontSize: "12px" }}>
                            <i className="bi bi-geo-alt"></i>
                            {dealData?.city_name}, {dealData?.state_name}
                        </div>
                    </div>
                    <Row className="g-3">
                        <Col md={6}>
                            <span style={miniLabelStyle}>Type</span>
                            <p className="mb-0 fw-medium fs-13">{getValueOrDash(dealData?.business_type)}</p>
                        </Col>
                        <Col md={6}>
                            <span style={miniLabelStyle}>Owner</span>
                            <p className="mb-0 fw-medium fs-13">{getValueOrDash(dealData?.company_owner_name)}</p>
                        </Col>
                        <Col md={12}>
                            <span style={miniLabelStyle}>Company Email</span>
                            <p className="mb-0 fw-medium fs-13 text-break">{getValueOrDash(dealData?.company_email)}</p>
                        </Col>
                        <Col
                            md={12}
                            className="mb-0 d-flex align-items-center"
                        >
                            <div>
                                <p className="mb-0" >
                                    Phone
                                </p>
                                <p className="mb-0" >
                                    {getMobileNumberByType(
                                        dealData?.company_phone,
                                        "Mobile",
                                    )}
                                </p>
                            </div>
                        </Col>
                        <Col
                            md={12}
                            className="mb-0 d-flex align-items-center"
                        >
                            <div>
                                <p className="mb-0" >
                                    Email
                                </p>
                                <p className="mb-0" >
                                    {getValueOrDash(dealData?.company_email)}
                                </p>
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* Internal Details */}
                {renderSection("System Internal", [
                    { label: "Created By", value: dealData?.lead_added_name, icon: faUserPlus },
                    { label: "Source", value: dealData?.source_title, icon: faRepeat },
                    { label: "Created Date", value: formatDate(dealData?.created_at), icon: faCalendarPlus },
                    { label: "Updated Date", value: formatDate(dealData?.updated_at), icon: faCalendar },
                    { label: "Updated By", value: dealData?.lead_updated_name, icon: faUser },
                ], true)}

                {/* Social Profiles */}
                <div className="px-4 py-3 border-top">
                    <p className="mb-3 " style={{ fontSize: "1.2rem", letterSpacing: "0.3px", fontWeight: 300 }}>Social Details</p>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "16px"
                        }}
                    >
                        {renderSocialIcon("Facebook", <FaFacebook />, dealData?.facebook, "#1877F2")}
                        {renderSocialIcon("Instagram", <FaInstagram />, dealData?.instagram, "#E4405F")}
                        {renderSocialIcon("Twitter", <FaTwitter />, dealData?.twitter, "#1DA1F2")}
                        {renderSocialIcon("Linkedin", <FaLinkedinIn />, dealData?.linkedin, "#0A66C2")}
                    </div>
                </div>

                <style jsx>{`
                .social-link-hover:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
                    filter: brightness(0.95);
                }
                .social-link-hover:hover {
                    transform: translateY(-2px);
                    filter: brightness(0.9);
                }

                .info-sidebar p {
                    line-height: 1.4;
                }

                .info-sidebar label {
                    user-select: none;
                }
            `}</style>
            </div>
        </>
    )
}


const miniLabelStyle = {
    fontSize: "12px",
    fontWeight: "400",
    color: "#94a3b8",
    display: "block",
    marginBottom: "2px"
};